import React, {Component} from 'react'
import {Button, Col, Form, Input, Modal, Row, Select, Table} from 'antd'
import {ArrowDownOutlined, ArrowUpOutlined, DeleteOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import {inject, observer} from 'mobx-react'
import { t } from 'i18next'
const storage = window.localStorage

const {TextArea} = Input
const {confirm} = Modal

@inject('reportManagementStore', 'routerStateModel', 'accountStore', 'reportTagStore')
@observer
class FormModal extends Component {
  formRef = React.createRef()
  state = {
    isLock: false,
    analysisLoading: false,
    canAdd: true,
    isTypeDisabled: false,
    isShowType: '查询语句',
    isEdit: false,
    exportPermissionsList: []
  }

  handleOk = () => {
    const {handleCancel, handleSearch, reportManagementStore, reportId, reportStatus} = this.props
    
    this.formRef.current.validateFields().then(fieldsValue => {
      reportManagementStore.saveReport({...fieldsValue, id: reportId, status: reportStatus}).then(res => {
        if (res?.code === 0) {
          handleCancel('modalVisible')
          handleSearch()
        }
      })
    })
  }

  handleUnlock = () => {
    const {t} = this.props
    let _this = this
    _this.setState({isLock: false, canAdd: true})

    // confirm({
    //   title: t(`reportManagement.unlock`),
    //   icon: <QuestionCircleFilled/>,
    //   content: t(`reportManagement.unlockClear`),
    //   okText: t(`general.ok`),
    //   cancelText: t(`general.cancel`),
    //   onOk() {
    //     _this.setState({isLock: false,canAdd:true})
    //     _this.formRef.current.setFieldsValue({conditions: []})
    //   },
    //   onCancel() {
    //     console.log('Cancel')
    //   },
    // })

  }

  analysisSql = () => {
    this.setState({analysisLoading: true})
    const {reportManagementStore} = this.props
    const {current} = this.formRef
    const sql = current.getFieldValue('sqlScript') 
    const sqlSelect = [...current.getFieldValue('conditions')]
    const sqlPermissions = [...current.getFieldValue('reportDataPermissions')]

    reportManagementStore.analysisReportSql({sql, sqlSelect, sqlPermissions}).then(res => {
      if (res.code === 0) {
        current.setFieldsValue({conditions: res.data.sqlSelect})
        this.setState({isLock: true, canAdd: false})
      }
      // current.setFieldsValue({conditions: res.data})
      this.setState({analysisLoading: false})
    }).catch(() => {
      this.setState({analysisLoading: false})
    })
  }

  validatePbiUrl = (rule, value, callback) => {
    const url = 'https://'
    if (value && value.substring(0, 8) !== url) {
      callback('请输入正确的报表地址，以https://开头')
    } else {
      callback() // 验证通过
    }
  }

  onConditionNameChange = (index, e) => {
    const {reportManagementStore} = this.props
    const {reportSqlList} = reportManagementStore
    const {current} = this.formRef
    const tempArr = [...current.getFieldValue('conditions')]

    tempArr[index].type = reportSqlList.filter(item => item.name === e)[0]?.type
    current.setFieldsValue({
      'conditions': tempArr
    })
  }

  onRolesChange = value => {
    const {reportManagementStore} = this.props
    const {reportRoleList} = reportManagementStore
    const downloadRole = this.formRef.current.getFieldValue('downloadRoles')
    const commonItems = downloadRole.filter(item => value.includes(item))
    this.formRef.current.setFieldsValue({ 'downloadRoles': commonItems })
    this.setState({
      exportPermissionsList: reportRoleList.filter(item => value.includes(item.id))
    })
  }

  onViewChange = (fieldName, value) => {
    const { reportManagementStore } = this.props
    const { reportRoleList } = reportManagementStore

    const reportDataPermissions = [...this.formRef.current.getFieldValue('reportDataPermissions')] || [];
    const downloadRole = reportDataPermissions[fieldName]?.downloadRoles || [];
    reportDataPermissions[fieldName].downloadRoles = downloadRole.filter(item => value.includes(item))
    this.formRef.current.setFieldsValue({ 'reportDataPermissions': reportDataPermissions });

    this.setState(prevState => ({
      exportPermissionsList: {
        ...prevState.exportPermissionsList,
        [fieldName]: reportRoleList.filter(item => value.includes(item.id)),
      },
    }));
  };

  componentDidMount() {
    const { reportId, reportManagementStore, routerStateModel, accountStore } = this.props;
    const { current } = this.formRef;
    this.setState({ isTypeDisabled: false });
    const { isTabHas } = accountStore;
    // if(!isTabHas) {
      if (reportId) {
        this.setState({ analysisLoading: true, isTypeDisabled: true, isEdit: true });
        reportManagementStore.getReportDetail(reportId).then(res => {
          const { type, roles, reportDataPermissions } = res.data || {};
    
          if (type === '查询语句'){
          // 初始化每一行的 exportPermissionsList
          const exportPermissionsList = {};
          reportDataPermissions.forEach((permission, index) => {
            const fieldName = `${index}`;
            exportPermissionsList[fieldName] = reportManagementStore.reportRoleList.filter(item => permission.viewPermissions.includes(item.id));
          });

          this.setState({
            isShowType: type,
            exportPermissionsList,
          });

          current.setFieldsValue({
            ...res.data,
            downloadRoles: res?.data?.downloadRoles || [],
            reportDataPermissions: reportDataPermissions.map(permission => ({
              ...permission,
              downloadRoles: permission.downloadRoles || [],
            })),
          });
        }
    

        if(type === 'PowerBI'){
          current.setFieldsValue({
            ...res.data,
            downloadRoles: res?.data?.downloadRoles || []
          })
          this.setState({
            isShowType: type,
            exportPermissionsList: reportManagementStore.reportRoleList.filter(item => roles?.includes(item.id))
          })
        }   
    
          if (type === '查询语句') { this.analysisSql(); }
          if (type === 'PowerBI') {
            this.setState({ isLock: true });
          }
          this.setState({ analysisLoading: false });
        });
      }
    // }
  }

  render() {
    const {t, modalVisible, handleCancel, reportManagementStore, reportTagStore} = this.props
    const {reportRoleList, reportSqlList, reportConditionOperatorList} = reportManagementStore
    const {tagList} = reportTagStore
    const {isLock, analysisLoading, canAdd, isShowType, isTypeDisabled, isEdit, exportPermissionsList} = this.state

    return (
      <Modal
        title={isEdit ? `${t(`general.edit`)}${t(`reportManagement.report`)}` : `${t(`general.add`)}${t(`reportManagement.report`)}`}
        width="70%"
        closable={true}
        onCancel={() => { handleCancel('modalVisible') }}
        visible={modalVisible}
        maskClosable={false}
        destroyOnClose={true}
        centered
        footer={[
          <Button key="Save" disabled={!isLock} type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
          <Button key="Cancel" onClick={() => { handleCancel('modalVisible') }}>{t(`general.cancel`)}</Button>,
        ]}
      >
        <Form ref={this.formRef} key="addMapping" layout="vertical">
          <Row justify="start" gutter={[10, 0]}>
            <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
              <Form.Item name="reportName" label={t(`reportManagement.reportName`)} rules={[{
                required: true,
                message: `${t(`general.pleaseEnter`)}${t(`reportManagement.reportName`)}${t(`general.withoutSpecialChats`)}`,
                pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
              }]}>
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>

            {
              isShowType === 'PowerBI'
                ?
                <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                  <Form.Item name="roles" label={t(`reportManagement.viewPermissions`)} rules={[{
                    required: true,
                    message: `${t(`general.pleaseEnter`)}${t(`reportManagement.viewPermissions`)}`,
                  }]}>
                    <Select
                      placeholder={t(`general.pleaseSelect`)}
                      allowClear
                      mode="multiple"
                      showArrow
                      maxTagCount="responsive"
                      onChange={this.onRolesChange}
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {
                        reportRoleList.length > 0
                          ? reportRoleList.map(item => <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>)
                          : null
                      }
                    </Select>
                  </Form.Item>
                </Col> : null
            }
            {/* {
              isShowType !== 'PowerBI'
                ? <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                  <Form.Item name="downloadRoles" initialValue={[]} label={t(`reportManagement.exportPermissions`)} rules={[{
                    required: false,
                    message: `${t(`general.pleaseEnter`)}${t(`reportManagement.exportPermissions`)}`,
                  }]}>
                    <Select
                      placeholder={t(`general.pleaseSelect`)}
                      allowClear
                      mode="multiple"
                      showArrow
                      maxTagCount="responsive"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {
                        exportPermissionsList.length > 0
                          ? exportPermissionsList.map(item => <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>)
                          : null
                      }
                    </Select>
                  </Form.Item>
                </Col>
                : null
            } */}
            <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
              <Form.Item name="type" label={t(`reportManagement.reportType`)} rules={[{
                required: true,
                message: `${t(`general.pleaseEnter`)}${t(`reportManagement.reportType`)}`,
              }]}>
                <Select disabled={isTypeDisabled} placeholder={t(`general.pleaseSelect`)} allowClear onChange={(value) => {
                  this.setState({
                    isShowType: value,
                    isLock: value !== '查询语句',
                  })
                  if (value === 'PowerBI') {
                    this.formRef.current.setFieldsValue({'downloadRoles': []})
                  }
                }}>
                  <Select.Option key={0} value={'查询语句'}>查询语句</Select.Option>
                  <Select.Option key={1} value={'PowerBI'}>PowerBI</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            {isShowType === '查询语句' ? <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
              <Form.Item name="datasourceTagIds" label={t(`menu.reportTag`)} rules={[{
                required: true,
                message: `${t(`general.pleaseEnter`)}${t(`menu.reportTag`)}`,
              }]}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear mode="multiple" showArrow maxTagCount="responsive" maxTagTextLength={20}>
                  {
                    tagList.length > 0
                      ? tagList.map(item => <Select.Option key={item.id} value={item.id}>{item.tagName}</Select.Option>)
                      : null
                  }
                </Select>
              </Form.Item>
            </Col> : null}
          </Row>
          {isShowType === 'PowerBI' && !isTypeDisabled && (
            <Row justify="start" gutter={[10, 0]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                <Form.Item name="pbiUrl" label={t(`reportManagement.reportUrl`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)}${t(`reportManagement.reportUrl`)}`,
                }, {
                  validator: this.validatePbiUrl,
                }]}>
                  <TextArea rows={8} placeholder={t(`general.pleaseEnter`)} allowClear/>
                </Form.Item>
              </Col>
            </Row>)}
          {isShowType === '查询语句' && (
            <Row justify="start" gutter={[10, 0]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                <Form.Item name="sqlScript" label={t(`reportManagement.conditionSql`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)}${t(`reportManagement.conditionSql`)}`,
                }]}>
                  <TextArea disabled={isLock} rows={8} placeholder={t(`general.pleaseEnter`)} allowClear/>
                </Form.Item>
              </Col>
            </Row>)}
          {isShowType === '查询语句' && (
            <Row justify="start" gutter={[10, 0]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                <Form.Item name="reportDescription" label={t(`reportManagement.reportDes`)} rules={[{
                  required: false,
                  message: `${t(`general.pleaseEnter`)}${t(`reportManagement.reportDes`)}`,
                }]}>
                  <TextArea rows={4} placeholder={t(`general.pleaseEnter`)} allowClear/>
                </Form.Item>
              </Col>
            </Row>)}
          

          {isShowType === '查询语句' && (
            <Row>
              <Form.List name="reportDataPermissions" initialValue={[]}>
                {(fields, { add, remove, move }) => (
                  <>
                    <Col span={4} style={{ fontSize: '18px' }}><span style={{ color: 'red' }}>* </span> {t(`reportManagement.reportDataPermissions`)}</Col>
                    <Col span={20} style={{ textAlign: 'right' }}>
                      <Button
                        key="add"
                        // disabled={canAdd}
                        type='danger'
                        onClick={() => { add() }}>{t(`reportManagement.conditionAdd`)}
                      </Button>
                    </Col>
                    <Col span={24}>
                      <Table
                        dataSource={fields}
                        pagination={false}
                        style={{ margin: '10px 0' }}
                      // loading={analysisLoading}
                      >
                        <Table.Column
                          title={t(`reportManagement.viewPermissions`)}
                          dataIndex="viewPermissions"
                          key="viewPermissions"
                          render={(text, row) => {
                            return (
                              <Form.Item name={[row.name, 'viewPermissions']}  rules={[{
                                required: true,
                                message: `${t(`general.pleaseEnter`)}${t(`reportManagement.viewPermissions`)}`,
                              }]}>
                                <Select
                                  placeholder={t(`general.pleaseSelect`)}
                                  allowClear
                                  mode="multiple"
                                  showArrow
                                  maxTagCount="responsive"
                                  onChange={(value) => this.onViewChange(row.name, value)}
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                >
                                  {
                                    reportRoleList.length > 0
                                      ? reportRoleList.map(item => <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>)
                                      : null
                                  }
                                </Select>
                              </Form.Item>
                            )
                          }}
                        />
                        <Table.Column
                          title={t(`reportManagement.exportPermissions`)}
                          dataIndex="downloadRoles"
                          key="downloadRoles"
                          render={(text, row) => {
                             // 获取当前行的 exportPermissionsList
                            const currentExportPermissionsList = this.state.exportPermissionsList[row.name] || [];

                            return (
                              <Form.Item name={[row.name, 'downloadRoles']} initialValue={[]}>
                                <Select
                                  placeholder={t(`general.pleaseSelect`)}
                                  allowClear
                                  mode="multiple"
                                  showArrow
                                  maxTagCount="responsive"
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                >
                             {
                             currentExportPermissionsList.length > 0 ? 
                             currentExportPermissionsList.map(item => (
                              <Select.Option key={item.id} value={item.id}>
                                {item.name}
                              </Select.Option>
                            ))
                          : 
                          null
                          }
                                </Select>
                              </Form.Item>
                            )
                          }}
                        />
                         <Table.Column title={t(`reportManagement.reportPermissionsFilter`)} dataIndex="permissionsFilter" key="permissionsFilter" render={(text, row) => {
                          return (
                            <Form.Item name={[row.name, 'permissionsFilter']} rules={[{
                              required: false,
                              message: `${t(`general.pleaseEnter`)} ${t(`reportManagement.reportPermissionsFilter`)}`,
                              pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                            }]}>
                              <Input onChange={() => this.setState({ isLock: false })}/>
                            </Form.Item>
                          )
                        }}/>
                         
                        <Table.Column width={200} align="center" title={t(`general.action`)} key="Action" render={(text, row, index) => (<>
                          <Button type="link" onClick={() => remove(index)} icon={<DeleteOutlined />} title={t(`general.delete`)} />
                          {index !== 0 && (
                            <Button type="link" onClick={() => move(index, index - 1)} icon={<ArrowUpOutlined />} title={t(`general.delete`)} />)}
                          {fields.length !== index + 1 && (
                            <Button type="link" onClick={() => move(index, index + 1)} icon={<ArrowDownOutlined />} title={t(`general.delete`)} />)}
                        </>
                        )} />
                      </Table>
                    </Col>
                  </>
                )}
              </Form.List>
            </Row>)
          }

            {isShowType === '查询语句' && (
            <Row>
              <Form.List name="conditions" initialValue={[]}>
                {(fields, {add, remove, move}) => (
                  <>
                    <Col span={4} style={{fontSize: '18px'}}>{t(`reportManagement.conditions`)}</Col>

                    <Col span={20} style={{textAlign: 'right'}}>
                      <Button key="unlock" style={{marginRight: '10px'}} onClick={this.handleUnlock}
                              disabled={!isLock}>{t(`reportManagement.unlock`)}</Button>
                      <Button key="analysis" style={{marginRight: '10px'}} loading={analysisLoading}
                              onClick={this.analysisSql} disabled={isLock}>{t(`reportManagement.analysis`)}</Button>
                      <Button
                        key="add"
                        disabled={canAdd}
                        type='danger'
                        onClick={() => { add() }}>{t(`reportManagement.conditionAdd`)}
                      </Button>
                    </Col>

                    <Col span={24}>
                      <Table
                        dataSource={fields}
                        pagination={false}
                        style={{margin: '10px 0'}}
                        // loading={analysisLoading}
                      >
                        <Table.Column
                          title={t(`reportManagement.conditionName`)}
                          dataIndex="name"
                          key="name"
                          render={(text, row) => {
                            return (
                              <Form.Item
                                name={[row.name, 'name']}
                                rules={[{
                                  required: true,
                                  message: `${t(`general.pleaseSelect`)}${t(`reportManagement.conditionName`)}`,
                                }]}>
                                <Select
                                  placeholder={t(`general.pleaseSelect`)}
                                  allowClear
                                  onChange={(e) => this.onConditionNameChange(row.name, e)}
                                >
                                  {
                                    reportSqlList.length > 0
                                      ? reportSqlList.map(item => (
                                        <Select.Option key={item.name} value={item.name}>{item.name}</Select.Option>
                                      ))
                                      : null
                                  }
                                </Select>
                              </Form.Item>
                            )
                          }}
                        />
                        <Table.Column
                          title={t(`reportManagement.conditionOperator`)}
                          dataIndex="operator"
                          key="operator"
                          render={(text, row) => {
                            return (
                              <Form.Item
                                name={[row.name, 'operator']}
                                rules={[{
                                  required: true,
                                  message: `${t(`general.pleaseSelect`)}${t(`reportManagement.conditionOperator`)}`,
                                }]}>
                                <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                                  {
                                    reportConditionOperatorList.length > 0
                                      ? reportConditionOperatorList.map(item => <Select.Option key={item} value={item}>{item}</Select.Option>)
                                      : null
                                  }
                                </Select>
                              </Form.Item>
                            )
                          }}
                        />
                        <Table.Column
                          title={t(`reportManagement.conditionType`)}
                          dataIndex="type"
                          key="type"
                          render={(text, row) => {
                            return (
                              <Form.Item name={[row.name, 'type']}>
                                {this.formRef.current.getFieldValue(['conditions', row.name, 'type'])}
                              </Form.Item>
                            )
                          }} />
                        <Table.Column width={200} align="center" title={t(`general.action`)} key="Action" render={(text, row, index) => (<>
                          <Button type="link" onClick={() => remove(index)} icon={<DeleteOutlined />} title={t(`general.delete`)} />
                          {index !== 0 && (
                            <Button type="link" onClick={() => move(index, index - 1)} icon={<ArrowUpOutlined />} title={t(`general.delete`)} />)}
                          {fields.length !== index + 1 && (
                            <Button type="link" onClick={() => move(index, index + 1)} icon={<ArrowDownOutlined />} title={t(`general.delete`)} />)}
                        </>
                        )} />
                      </Table>
                    </Col>
                  </>
                )}
              </Form.List>
            </Row>)
          }
        </Form>
      </Modal>
    )
  }
}

export default withTranslation()(FormModal)
